import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import SCALogo from '~/assets/images/logo.png';

import AbastekLogo from '~/assets/images/logoabastek.png';

import { Progress } from '~/components';

import { Wrapper, WrapperLog, Logo } from './styles';

export default function AuthLayout({ children }) {
  const loading = useSelector((state) => state.auth.loading);
  const loadingEsqueciMinhaSenha = useSelector(
    (state) => state.esqueciminhasenha.loading
  );

  return (
    <Wrapper>
      <Progress loading={loading || loadingEsqueciMinhaSenha} />
      <WrapperLog>
        <img src={SCALogo} alt="Logomarca SGTA+" />
        {children}
        {/* <Logo>abastek</Logo> */}
        <Logo>
          <img
            src={AbastekLogo}
            alt="Logo Abastek com escrita em preto com o t laranja"
          />
        </Logo>

        <Typography class="versao">
          versão:{' '}
          {new Date(process.env.REACT_APP_TIMESTAMP_BUILD * 1000)
            .toISOString()
            .slice(0, 16)
            .replace('T', '.')
            .replace(':', '')
            .replace('-', '')
            .replace('-', '')}{' '}
          build: {process.env.REACT_APP_COMMIT}
        </Typography>
      </WrapperLog>
    </Wrapper>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
